export default __webpack_public_path__ + "static/media/Flexibilty.1e2ceb5d.svg";